// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;

  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
`;
const Inner = styled.div`
  width: calc(100% - 50px);
  margin: 25px 25px 120px 25px;

  background-image: url("/assets/noise-pattern@2x.png");
  background-size: 200px 200px;

  position: relative;

  @media (max-width: 1100px) {
    margin-bottom: ${scale(1100, 767, 120, 40, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 25px 0 0 0;
    margin: 0;
    display: flex;
    flex-direction: column;

    :before {
      content: "";
      position: absolute;
      height: 100px;
      width: 100%;
      background-color: white;
      bottom: 0;
      left: 0;
    }
  }
`;
const Title = styled.div`
  width: calc(100% - 256px);
  padding: 50px 128px 62px 128px;
  float: left;

  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  text-align: center;
  color: #3949ab;

  @media (max-width: 1400px) {
    width: calc(100% - 40px);
    padding: 50px 20px 62px 20px;
  }

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 50, 20, "vw")} 20px
      ${scale(1100, 767, 62, 23, "vw")} 20px;

    font-size: ${scale(1100, 767, 42, 27, "vw")};
    line-height: ${scale(1100, 767, 42 * 1.38, 27 * 2.15, "vw")};
    letter-spacing: ${scale(1100, 767, 0.6, 0.4, "vw")};
  }
  @media (max-width: 700px) {
    float: left;

    font-size: 22px;
    line-height: 1.27;
    letter-spacing: 0.3px;

    width: calc(100% - 46px);

    margin: 0 23px 23px 23px;
    padding: 0;

    order: 1;
  }
`;
const Body = styled.div`
  padding: 0 0 20px calc(50% + 106px);
  width: 414px;

  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 414, 290, "vw")};
    font-size: ${scale(1100, 767, 18, 12, "vw")};
    line-height: ${scale(1100, 767, 18 * 1.67, 12 * 1.75, "vw")};
    letter-spacing: ${scale(1100, 767, 0.3, 0.2, "vw")};

    padding: 0 0 20px ${scale(1100, 767, 631, 422, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 0 23px 23px 23px;

    order: 3;

    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.2px;

    position: relative;
  }
`;
const Embed = styled.div`
  position: absolute;
  left: calc(50% - 520px);
  top: 174px;

  width: 596px;
  height: 334px;

  @media (max-width: 1100px) {
    top: ${scale(1100, 767, 174, 101, "vw")};
    width: ${scale(1100, 767, 596, 400, "vw")};
    height: ${scale(1100, 767, 334, 225, "vw")};
    left: ${scale(1100, 1000, 5, 0, "vw")};
  }
  @media (max-width: 1000px) {
    left: 0;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    height: 0;
    padding-bottom: 56.5%;

    position: relative;
    top: 0;
    left: 0;

    margin: 0 23px 23px 23px;
    order: 2;
  }
`;
const ResponsiveDiv = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

class Video extends ArticleAbstract {
  render() {
    return (
      <Wrapper>
        <Inner>
          <Title>{this.title()}</Title>
          <Body>{this.body()}</Body>
          <Embed>
            <ResponsiveDiv>
              <iframe
                src="https://www.youtube.com/embed/HOyy6ImoYHI"
                title={this.title()}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </ResponsiveDiv>
          </Embed>
        </Inner>
      </Wrapper>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js